import { useMsal } from "@azure/msal-react";
import { Stack, Text, Button } from "@chakra-ui/react";

import { CenteredLayout } from "../../components/2/CenteredLayout";
import { OuterShell as OuterShell2 } from "../../components/2/Shell";
import { ApiScope } from "../../components/app-config";

export const WaitingForNigol = () => {
  const { instance, inProgress } = useMsal();

  const isInLoginProcess = inProgress === "login";

  return (
    <OuterShell2>
      <CenteredLayout>
        <Stack gap="6">
          <Text color="fg.muted" textAlign="center">
            Où les collaborateurs rejoignent leurs jobs & agences et où les codes postaux prennent
            vie.
          </Text>
        </Stack>

        <>
          <Button
            variant="outline"
            onClick={() => {
              void instance
                .loginPopup({
                  scopes: ["openid"],
                  extraScopesToConsent: [ApiScope],
                })
                .then(r => {
                  instance.setActiveAccount(r.account);
                });
            }}
            disabled={isInLoginProcess}
          >
            {isInLoginProcess ? "Connexion en cours" : "Se connecter avec Microsoft"}
          </Button>

          <Stack gap="3" justify="center">
            <Text textStyle="sm" color="fg.muted" textAlign="center">
              L'accès à cette interface est limité, si tu ne peux pas t'y connecter, rapproche-toi
              de ton manager.
            </Text>
          </Stack>
        </>
      </CenteredLayout>
    </OuterShell2>
  );
};
